<template>
<div class="popup tit private">
    <div class="pop-head">
      <h3 class="pop-tit">개인정보 수집 &middot; 이용 동의</h3>
    </div>
    <div class="pop-cont"> 
      <div class="userManagePrivateAgree">
        <p>LG유플러스는 U+메시지허브이지 서비스를 제공하기 위해 아래와 같이 개인 정보를 수집 및 이용합니다.</p>
        <p>LG유플러스는 최초 회원가입 시 서비스 제공을 원활하게 하기 위해 필요한 최소한의 정보를 수집하고 있으며, 회사가 제공하는 서비스 이용에 따른 결제 및 환불, 서비스 이행 등에 필요한 정보를 추가로 수집할 수 있습니다.</p>
        <table>
          <thead>
            <tr>
              <th>수집항목</th>
              <th>이용목적</th>
              <th>보유 및 이용 기간</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>아이디, 이름, 휴대폰 번호, 이메일</td>
              <td>서비스 이용을 위한 <br/>사용자 등록</td>
              <td><strong>해지 후 6개월까지 보관</strong></td>
            </tr>
          </tbody>
        </table>
        <p>※ 개인정보 수집&middot;이용 동의는 거부할 수 있습니다. 다만, 동의 거부시에는 서비스 이용이 제한될 수 있습니다.</p>
        <div class="chkbox">
          <input type="checkbox" class="chk" id="privacy" v-model="agreePrivacy" />
          <label for="privacy">위 내용에 대해 충분한 설명을 듣고, 내용을 읽어보있으며 이를 이해하며 동의합니다</label>
        </div>
      </div>

    </div>
    <div class="pop-btn2 center">
      <button type="button" :disabled="!agreePrivacy" class="btn large_pink" @click="fnCreateUserEmit">저장</button>
      <button type="button" class="btn large_white" @click="ModalClose">취소</button>
    </div>
  </div>

</template>
<script>
export default {
  data(){
    return{
      agreePrivacy:false
    }
  },
  created(){
    this.agreePrivacy = false;
  },
  methods:{
    //모달 창 닫기
    ModalClose() {
      this.agreePrivacy = false;
      //eventChk값 초기화
      this.eventChk = false;
      var dimmed = document.getElementsByClassName("dimmed");
      var wrap = document.getElementsByClassName("popup-wrap");
      var obj = wrap[0].childElementCount;
      dimmed[0].style.display = "none";
      wrap[0].style.display = "none";
      for (var i = 0; i < obj; i++) {
        var target = document.getElementsByClassName("popup");
        target[i].style.display = "none";
        target[i].classList.remove("open");
      }
    },
    fnCreateUserEmit(){
      this.$emit("fnCreateUserConfirm", this.agreePrivacy)
      this.ModalClose()
    }
  }
}
</script>
